import { ProductParams } from "@/api/home";
import { API } from "@akc/biz-api";

// 资源位卡片类型
export enum EResourceCardType {
  BANNER = 1, // banner
  LIVE = 2,   // 直播间
  RANK = 3,   // 榜单
}

/**
 * 获取商品feed流列表
 */
export async function getProductFeedList(params?: ProductParams) {
  // 构建查询参数
  const { shopBizCode = "", distributorId = "", searchRequestId = "" } = params || {};
  let url = "/api/mshop/mshop-aggr-prod/outer/product/feedList";
  const res = await API.post({
    hostID: "h5shop",
    path: url,
    body: params,
    headers: {
      "app-request-id": (searchRequestId || "") as string,
    },
  });

  return res;
}
